import { render, staticRenderFns } from "./edit.vue?vue&type=template&id=dd591e0a&scoped=true&"
import script from "./edit.vue?vue&type=script&lang=js&"
export * from "./edit.vue?vue&type=script&lang=js&"
import style0 from "./edit.vue?vue&type=style&index=0&id=dd591e0a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd591e0a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/.jenkins/workspace/crm-ui/code/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dd591e0a')) {
      api.createRecord('dd591e0a', component.options)
    } else {
      api.reload('dd591e0a', component.options)
    }
    module.hot.accept("./edit.vue?vue&type=template&id=dd591e0a&scoped=true&", function () {
      api.rerender('dd591e0a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/crm/order/salesOrder/edit.vue"
export default component.exports